import React, { useRef } from "react";
import { Calendar } from "primereact/calendar";
import Translate from "Components/Translate";
import { Controller } from "react-hook-form";
import moment from "moment";

const DateInput = ({ register, inputName, errors, control, oldValue }) => {
  const { name, title, required } = inputName;
  const isReq = required === undefined ? true : false;

  // Ref for calendar input
  const calendarRef = useRef(null);

  return (
    <div style={{ width: "300px" }}>
      <div className="flex flex-column ">
        <label>
          <Translate>{title}</Translate>
          {isReq && <span className="text-danger">*</span>}
        </label>
        {getDate(oldValue) ? (
          <Controller
            name={name}
            control={control}
            defaultValue={getDate(oldValue)}
            render={({ field }) => (
              <Calendar
                id={field.name}
                value={new Date(field.value)}
                onChange={(e) => {
                  const value = moment(e.value).format("YYYY-MM-DD");
                  value === "Invalid date"
                    ? field.onChange("")
                    : field.onChange(value);
                }}
                dateFormat="dd/mm/yy"
                showIcon
                autoComplete="off"
                size={10}
                showClear
                inputRef={(el) => {
                  field.ref(el);
                  calendarRef.current = el;
                }} // Set input reference
                onClick={() => calendarRef.current?.focus()} // Focus on the input when clicked
              />
            )}
          />
        ) : (
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <Calendar
                onChange={(e) => {
                  const value = moment(e.value).format("YYYY-MM-DD");
                  value === "Invalid date"
                    ? field.onChange("")
                    : field.onChange(value);
                }}
                dateFormat="dd/mm/yy"
                showIcon
                autoComplete="off"
                size={10}
                showClear
                value={field.value ? new Date(field.value) : ""}
                inputRef={(el) => {
                  field.ref(el);
                  calendarRef.current = el;
                }} // Set input reference
                onClick={() => calendarRef.current?.focus()} // Focus on the input when clicked
              />
            )}
          />
        )}

        {errors[name] && (
          <small className="text-danger">
            <Translate>{errors[name].message}</Translate>
          </small>
        )}
      </div>
    </div>
  );
};

export default DateInput;

const getDate = (param) => {
  try {
    return param.substring(0, 10);
  } catch {
    return null;
  }
};
